export default __webpack_public_path__ + "static/media/4.44cd2f8a.webp";